// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"6f95d7b2","143":"afcf8962","144":"8e571dc2","494":"72874641","533":"d1e3c96e","651":"8a577bdd","690":"304e41e1","852":"25f6b2b7","940":"5a9a6a3d"}[chunkId] + ".chunk.js";
};